import { render } from "./multi-store-settings.vue?vue&type=template&id=cbacf63e"
import script from "./multi-store-settings.vue?vue&type=script&lang=js"
export * from "./multi-store-settings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__